import { ChatFragment } from '@school_ify/schoolify-repository/src/shared/types';

import { IAction } from 'redux/actions';

import { ChatTypes } from './types';

const {
  ADD_ACTIVE_ROOM,
  ADD_MESSAGE,
  CLEAN_CHAT_ROOM,
  CLEAN_ACTIVE_CHAT,
  FREE_TO_CHOOSE_INITIAL,
  ADD_ALL_MESSAGES,
  SOCKET_UPDATE,
  POP_NEW_MESSAGES,
  DELETE_MESSAGE,
  UPDATE_MESSAGE,
  SET_RESPONDING_MESSAGE,
  CLEAR_RESPONDING_MESSAGE,
  SET_REPLYS,
  UPDATE_REPLYS,
  ADD_REPLY,
  ADD_LIKE,
  DELETE_LIKE,
} = ChatTypes;

export const addActiveRoom = (
  payload: ChatFragment
): IAction<typeof ADD_ACTIVE_ROOM, ChatFragment> => ({
  type: ADD_ACTIVE_ROOM,
  payload,
});

type Message = {
  body: string;
  id: string;
  user_id: string;
  chat_id: string;
  responding?: any;
  replys: any[];
};
export const addMessage = (payload: Message): IAction<typeof ADD_MESSAGE, Message> => ({
  type: ADD_MESSAGE,
  payload,
});

export const addAllMessages = (payload: any): IAction<typeof ADD_ALL_MESSAGES, any> => ({
  type: ADD_ALL_MESSAGES,
  payload,
});

export const cleanChatRoom = (): IAction<typeof CLEAN_CHAT_ROOM, void> => ({
  type: CLEAN_CHAT_ROOM,
});

export const cleanActiveChat = (): IAction<typeof CLEAN_ACTIVE_CHAT, void> => ({
  type: CLEAN_ACTIVE_CHAT,
});

export const passInitialSelectorNext = (
  payload: boolean
): IAction<typeof FREE_TO_CHOOSE_INITIAL, boolean> => ({
  type: FREE_TO_CHOOSE_INITIAL,
  payload,
});

export const socketUpdate = (): IAction<typeof SOCKET_UPDATE, void> => ({
  type: SOCKET_UPDATE,
});

export const popNewMessages = (payload: any): IAction<typeof POP_NEW_MESSAGES, void> => ({
  type: POP_NEW_MESSAGES,
  payload,
});
export const deleteMessage = (payload: any): IAction<typeof DELETE_MESSAGE, void> => ({
  type: DELETE_MESSAGE,
  payload,
});

export const updateMessage = (payload: any): IAction<typeof UPDATE_MESSAGE, void> => ({
  type: UPDATE_MESSAGE,
  payload,
});
export const setRespondingMessage = (
  payload: any
): IAction<typeof SET_RESPONDING_MESSAGE, void> => ({
  type: SET_RESPONDING_MESSAGE,
  payload,
});
export const clearRespondingMessage = (): IAction<typeof CLEAR_RESPONDING_MESSAGE, void> => ({
  type: CLEAR_RESPONDING_MESSAGE,
});

export const setReplys = (payload: any): IAction<typeof SET_REPLYS, void> => ({
  type: SET_REPLYS,
  payload,
});
export const updateReplies = (payload: any): IAction<typeof UPDATE_REPLYS, void> => ({
  type: UPDATE_REPLYS,
  payload,
});

export const addReply = (payload: any): IAction<typeof ADD_REPLY, void> => ({
  type: ADD_REPLY,
  payload,
});

export const addLike = (payload: any): IAction<typeof ADD_LIKE, void> => ({
  type: ADD_LIKE,
  payload,
});

export const deleteLike = (payload: any): IAction<typeof DELETE_LIKE, void> => ({
  type: DELETE_LIKE,
  payload,
});
